export enum Namespaces {
    myMenu = "myMenu",
}
